// Hook for POST /projects/:projectId/settings/dashboard/reports/reorder

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';

export type ReorderDashboardReportsPayload = {
  'report-ids': string[];
};

export type ReorderDashboardReportsResponse = {
  success: boolean;
  message?: string;
};

const reorderDashboardReports = async (
  projectId: string,
  payload: ReorderDashboardReportsPayload
): Promise<ReorderDashboardReportsResponse> => {
  const res = await axios.put(
    `api/projects/${projectId}/settings/dashboard/reports/reorder`,
    payload
  );
  return res.data;
};

type UseReorderDashboardReportsOptions = {
  config?: UseMutationOptions<
    ReorderDashboardReportsResponse,
    Error,
    ReorderDashboardReportsPayload
  >;
};

export const useReorderDashboardReports = (
  projectId: string,
  options: UseReorderDashboardReportsOptions = {}
) => {
  const mutation = useMutation<
    ReorderDashboardReportsResponse,
    Error,
    ReorderDashboardReportsPayload
  >((payload) => reorderDashboardReports(projectId, payload), {
    ...options.config,
  });

  return {
    mutation,
    reorderDashboardReports: mutation.mutate,
    reorderDashboardReportsAsync: mutation.mutateAsync,
    data: mutation.data,
    error: mutation.error,
    isLoading: mutation.isLoading,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
  };
};
